const style = {
  tableWrapper: {
    sx: {
      margin: '32px 0px',
    },
  },
  tableScroll: {
    sx: {
      overflowX: 'auto',
    },
  },
  programDisabled: {
    sx: {
      py: 6,
      px: 2,
    },
  },
} as const;

export default style;
